import { render, staticRenderFns } from "./Family.vue?vue&type=template&id=ad093c96&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad093c96",
  null
  
)

export default component.exports